import { FunctionalComponent } from 'preact'
import { GetServerSideProps } from '../../server-middleware/context'
import { z } from 'zod'

export const widgetName = 'banner' as const

export const config = z.object({
  content: z.object({
    textAlignment: z.enum(['Left', 'Center', 'Right']),
    title: z.string(),
    description: z.string()
  }),
  buttons: z.object({
    primaryText: z.string(),
    primaryUrl: z.string(),
    secondaryText: z.string().optional(),
    secondaryUrl: z.string().optional()
  })
})

export type BannerElementConfig = z.infer<typeof config>

export const getServerSideProps: GetServerSideProps<BannerElementConfig, BannerElementConfig> = async (_, config) => {
  return config
}

const Banner: FunctionalComponent<BannerElementConfig> = ({ content, buttons }: BannerElementConfig) => {
  const isPrimaryButton = Boolean(buttons?.primaryUrl) && Boolean(buttons?.primaryText)
  const isSecondaryButton = Boolean(buttons?.secondaryUrl) && Boolean(buttons?.primaryText)
  const textAlignment = content.textAlignment.toLowerCase()
  return (
    <div className='qa-banner-container banner-container homepage-widget-wrapper'>
      <div className='sitewidth'>
        <div className={`col text-${textAlignment}`}>
          {Boolean(content?.title) && <h2 className='widget__heading'>{content.title}</h2>}
          {Boolean(content?.description) &&
            <div dangerouslySetInnerHTML={{ __html: content.description }} />}
        </div>
        {(isPrimaryButton || isSecondaryButton) &&
          <div className={`col text-${textAlignment} banner-widget__button`}>
            {isPrimaryButton && <a href={buttons.primaryUrl} className='btn--cta'>{buttons.primaryText}</a>}
            {isSecondaryButton && <a href={buttons.secondaryUrl} className='btn--secondary'>{buttons.secondaryText}</a>}
          </div>}
      </div>
    </div>
  )
}

export default Banner
